/**
 * Policy page — auto table of contents from headings
 */
(function () {
  'use strict';

  function slugify(text, index) {
    const base = String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    return base || `section-${index}`;
  }

  function initPolicyToc() {
    const content = document.querySelector('[data-policy-content]');
    const nav = document.querySelector('.wd-policy-toc__nav');
    const sidebar = document.querySelector('[data-policy-sidebar]');
    if (!content || !nav || !sidebar) return;

    const headings = content.querySelectorAll('h2, h3');
    if (!headings.length) return;

    const usedIds = new Set();
    const list = document.createElement('ul');

    headings.forEach((heading, index) => {
      let id = heading.id || slugify(heading.textContent, index + 1);
      while (usedIds.has(id)) {
        id = `${id}-${index + 1}`;
      }
      usedIds.add(id);
      heading.id = id;

      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.classList.add('wd-policy-toc__item--child');

      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', (e) => {
        e.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', `#${id}`);
      });

      item.append(link);
      list.append(item);
    });

    nav.append(list);
    sidebar.removeAttribute('hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPolicyToc);
  } else {
    initPolicyToc();
  }
})();
